import React, { Component } from 'react';
import { WaypointLoader } from 'js/user_cards/components/waypoint-loader';
import { ReaderCard } from './reader_card.wjs';
import { Spinner } from 'js/academia_components/transients/spinner';
import { $ } from 'global';

export default class ReaderCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      worksCount: null,
      ids: [],
      models: {},
      fetching: false,
      exhausted: false,
      page: 1,
      cursor: null,
    };
  }

  componentDidMount() {
    this.fetchReaderCards();

    // Use the correct API endpoint that we know works
    const worksCountUrl = $r.count_api_v0_user_works_path({
      subdomain_param: 'api',
      user_id: Aedu.User.current.id,
    });

    $.ajax({
      url: worksCountUrl,
      type: 'GET',
      dataType: 'json',
      success: (x) => this.setState({ worksCount: x.count }),
      error: () => {
        // Fallback if the API doesn't exist
        this.setState({ worksCount: 0 });
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filter !== this.props.filter) {
      this.setState(
        {
          ids: [],
          models: {},
          page: 1,
          exhausted: false,
          cursor: null,
        },
        this.fetchReaderCards,
      );
    }
  }

  fetchReaderCards = () => {
    if (this.state.fetching || this.state.exhausted) return;

    this.setState({ fetching: true });

    // Use the correct endpoint based on the filter
    let endpoint;
    switch (this.props.filter) {
      case 'highly_engaged':
        endpoint = 'highly_engaged_cards';
        break;
      case 'in_network':
        endpoint = 'in_network_cards';
        break;
      case 'in_field':
        endpoint = 'in_field_cards';
        break;
      case 'all':
      default:
        endpoint = 'get_cards';
        break;
    }

    // Build the URL with cursor if we have one
    let url = `/v0/readers/${endpoint}?subdomain_param=api&user_id=${Aedu.User.current.id}`;
    if (this.state.cursor) {
      url += `&cursor=${encodeURIComponent(this.state.cursor)}`;
    }

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: (response) => {
        // Handle the correct response structure
        if (response.success && response.user_cards) {
          const readers = response.user_cards.models || [];

          const newIds = readers.map((reader) => reader.reader.id);
          const newModels = {};

          readers.forEach((reader) => {
            newModels[reader.reader.id] = reader;
          });
          this.setState((prevState) => ({
            ids: [...prevState.ids, ...newIds],
            models: { ...prevState.models, ...newModels },
            fetching: false,
            exhausted: response.user_cards.exhausted,
            cursor: response.user_cards.cursor,
          }));
        } else {
          this.setState({
            fetching: false,
            exhausted: true,
          });
        }
      },
      error: (xhr, status, error) => {
        console.error('Error fetching reader cards:', error);
        console.error('Status:', status);
        console.error('Response:', xhr.responseText);
        this.setState({
          fetching: false,
          exhausted: true,
        });
      },
    });
  };

  renderCard = (id, index) => {
    if (index === this.state.ids.length - 4) {
      return (
        <div key={id}>
          <WaypointLoader
            fetching={this.state.fetching}
            exhausted={this.state.exhausted}
            fetcher={this.fetchReaderCards}
          />
          <ReaderCard
            reader={this.state.models[id].reader}
            read_events={this.state.models[id].read_events || []}
            recent_activity={this.state.models[id].recent_activity || []}
          />
        </div>
      );
    }
    return (
      <ReaderCard
        key={id}
        reader={this.state.models[id].reader}
        read_events={this.state.models[id].read_events || []}
        recent_activity={this.state.models[id].recent_activity || []}
      />
    );
  };

  render() {
    if (this.state.ids && this.state.ids.length > 0) {
      return (
        <div className="DesignSystem">
          <div className="wp-card__containerSpacer">
            <div>{this.state.ids.map(this.renderCard)}</div>
            <div>
              <Spinner show={this.state.fetching} />
            </div>
          </div>
        </div>
      );
    } else if (
      !this.state.exhausted &&
      this.state.ids &&
      this.state.ids.length === 0
    ) {
      return (
        <div className="DesignSystem">
          <Spinner show={true} />
        </div>
      );
    }

    let uploadButtonText;
    if (this.state.worksCount !== null) {
      uploadButtonText =
        this.state.worksCount === 0
          ? 'Upload a paper'
          : 'Keep uploading papers';

      return (
        <div className="DesignSystem">
          <div className="u-mb24x u-pb24x">
            <div className="u-taCenter u-fs24 u-tcGrayDark u-p8x u-m0x">
              There are no available reader profiles.
            </div>
            <div className="u-taCenter u-fs20 u-tcGrayDark">
              <a className="u-tcGreen u-clickable" href="/Papers/Upload">
                {uploadButtonText}
              </a>
              <span> and we'll notify you when you receive a new reader.</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="DesignSystem">
        <Spinner show={true} />
      </div>
    );
  }
}
